module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_03-cdf137436f244eb5ad12a287dae58243.png";